import React from 'react';
import { DefaultMultiTextInputSuggestion, MultiTextInput } from '..';
import { isValidEmail } from '../../../../util/string.util';
import Icon, { IconType } from '../../../icons/Icon';

interface MultiEmailInputProps {
  label: string;
  emails: Set<string>;
  setEmails: (emails: Set<string>) => void;
  invalid?: Set<string>;
}

export default function MultiEmailInput({
  label,
  emails,
  setEmails,
  invalid = new Set<string>(),
}: MultiEmailInputProps) {
  return (
    <MultiTextInput
      placeholder='Enter an email'
      label={label}
      itemBuilder={value => {
        return { leading: <Icon type={IconType.mail1} size={'size-4'} /> };
      }}
      values={emails}
      validate={email => isValidEmail(email) && !emails.has(email) && !invalid.has(email)}
      onValuesUpdated={emails => setEmails(emails)}
      suggestionBuilder={email => (
        <DefaultMultiTextInputSuggestion
          value={email}
          helpText={'Invite'}
          leading={<Icon type={IconType.mail1} size={'size-5'} />}
        />
      )}
    />
  );
}
